var exports = {
  "k": "x31de4314--dc113c--container",
  "Q": "x31de4314--dc113c--text",
};

module.exports = exports;
